
import { trigger } from '../events/customEvents'

import Enumeration from '../enumeration'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(localizedFormat)
dayjs.extend(utc)
dayjs.extend(timezone)

// Eastern time zone (handles EST/EDT automatically). Per business rule, counter
// offers and bid review countdowns are anchored to 5:00 PM Eastern, so expiry
// timestamps must always be displayed in Eastern time regardless of the
// viewer's local browser time zone.
const EASTERN_TIME_ZONE = 'America/Toronto'

const isInGroup = (loginSession, userGroupId) =>
{
	return (loginSession.user.usersRoleMemberships[0].userRole.userGroupId === userGroupId)
}

const isInRole = (loginSession, userRoleId) =>
{
    return loginSession.user.usersRoleMemberships.find(userRoleMembership => userRoleMembership.userRoleId === userRoleId) !== undefined
}

const displayApiError = (error) =>
{
	console.log('error: ' + error)

	let errorMessage = error.message
    try
    {
        if (error.response)
        {
            errorMessage = error.response.statusText
            if (error.response.data)
            {
                errorMessage = error.response.data.Message
            }
        }
    }
    catch {}
	trigger('raiseNotification', { title: 'Error', message: errorMessage, type: 'danger', duration: 5 })
}

const setExpiryTimeDisplay = (secondsRemaining) =>
{
    let hours = 0
    let minutes = 0
    let seconds = 0

    if (secondsRemaining > 0)
    {
        hours = Math.floor(secondsRemaining / (60 * 60))

        let divisor_for_minutes = secondsRemaining % (60 * 60)
        minutes = Math.floor(divisor_for_minutes / 60)

        let divisor_for_seconds = divisor_for_minutes % 60
        seconds = Math.ceil(divisor_for_seconds)
    }

	return {
		"h": hours,
		"m": minutes,
		"s": seconds
	}
}

const isElementViewable = (componentName, elementName, componentViewSettings) =>
{
	let isViewable = true
	if (componentName && elementName && (componentViewSettings && componentViewSettings.length > 0))
	{
		let viewSetting = componentViewSettings.find((componentViewSetting) => componentViewSetting.componentName === componentName && componentViewSetting.elementName === elementName)
		if (viewSetting)
		{
			isViewable = viewSetting.isVisible
		}
	}
	return isViewable
}

const isDealerBuyNowVisible = (auctionListItem) =>
{
	let isVisible = false
	if (auctionListItem && auctionListItem.auctionTier)
	{
		if (((auctionListItem.auctionTier.auctionTierTypeId === Enumeration.AuctionTierTypes.OriginalDealerTier || auctionListItem.auctionTier.auctionTierTypeId === Enumeration.AuctionTierTypes.MBPTier) && auctionListItem.marketPrice !== undefined && auctionListItem.marketPrice > 0) ||
			(auctionListItem.auctionTier.auctionTierTypeId === Enumeration.AuctionTierTypes.BiddingTier && auctionListItem.buyNowPrice !== undefined && auctionListItem.buyNowPrice > 0))
		{
			isVisible = true
		}
	}
	return isVisible
}

const isDealerPlaceBidVisible = (auctionListItem) =>
{
	let isVisible = false
	if (auctionListItem && auctionListItem.auctionTier)
	{
		if (auctionListItem.auctionTier.auctionTierTypeId !== Enumeration.AuctionTierTypes.MBPTier)
		{
			isVisible = true
		}
	}
	return isVisible
}

const bidButtonLabel = (auctionListItem, translator) =>
{
	let buttonLabel = ''
	if (translator)
	{
		buttonLabel = translator('Auctions.Listing.Place_Bid')
		if (auctionListItem.auctionTier.yourBid)
		{
			buttonLabel = translator('Auctions.Listing.View_Bidding')
		}
		// QA Feedback May-28: when the dealer is the high bidder and an active counter
		// offer exists, surface the accept-counter CTA directly on the card / detail
		// page so they can action it without hunting for the modal.
		if (auctionListItem.auctionTier.yourBid && auctionListItem.auctionTier.yourBid.counterBid)
		{
			buttonLabel = translator('Auctions.Listing.Accept_Counter')
		}
	}
	return buttonLabel
}

const numberDisplay = (number, fractionalDigits) =>
{
	let _number = ''
	if (number !== null && number !== undefined)
	{
		_number = number.toLocaleString('en-US', { maximumFractionDigits: fractionalDigits })
	}
	return _number
}

const priceDisplay = (price) =>
{
	let _price = 'N/A'
	if (price !== null && price !== undefined)
	{
		_price = price.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
	}
	return _price
}

const dateTimeDisplay = (dateTime) =>
{
	let _dateTime = ''
	if (dateTime !== null && dateTime !== undefined)
	{
		_dateTime = dayjs(dateTime).tz(dayjs.tz.guess()).format('lll')
	}
	return _dateTime
}

const dateTimeDisplayEastern = (dateTime) =>
{
	let _dateTime = ''
	if (dateTime !== null && dateTime !== undefined)
	{
		_dateTime = dayjs(dateTime).tz(EASTERN_TIME_ZONE).format('lll') + ' ET'
	}
	return _dateTime
}

const SiteService =
{
	isInGroup,
	displayApiError,
	setExpiryTimeDisplay,
    isInRole,
	isElementViewable,
	isDealerBuyNowVisible,
	isDealerPlaceBidVisible,
	bidButtonLabel,
	numberDisplay,
	priceDisplay,
	dateTimeDisplay,
	dateTimeDisplayEastern
}

export default SiteService
